import { createToastInterface } from 'vue-toastification';

import 'vue-toastification/dist/index.css';

const options = {
    timeout: 3000,
    hideProgressBar: true,
    toastClassName: 'toast-component',
};

export const Toast = createToastInterface(options);

export default {
    install(app) {
        app.config.globalProperties.$toast = Toast;

        app.provide('$toast', Toast);
    },
};
